import type { TableBorderFormatState, PictureFormatState } from 'owa-editor-ribbonplugin-store';
import type { RibbonViewStateInfo } from '../schema/RibbonViewStateInfo';
import type { MenuSection } from 'owa-acui';
import type * as lazyIndex from './lazyIndex';
import { LazyImport, LazyModule } from 'owa-bundling';

export const lazyModule: LazyModule<typeof lazyIndex> = new LazyModule<typeof lazyIndex>(
    () => import(/* webpackChunkName: "FormatControlsSections"*/ './lazyIndex'),
    { name: 'FormatControlsSections' }
);

export const lazyGetUndoRedoSections: LazyImport<
    typeof lazyIndex.getUndoRedoSections,
    LazyModule<typeof lazyIndex>
> = new LazyImport(lazyModule, m => m.getUndoRedoSections);
export const lazyGetCutCopyPasteSections: LazyImport<
    typeof lazyIndex.getCutCopyPasteSections,
    LazyModule<typeof lazyIndex>
> = new LazyImport(lazyModule, m => m.getCutCopyPasteSections);
export const lazyGetAlignSections: LazyImport<
    typeof lazyIndex.getAlignSections,
    LazyModule<typeof lazyIndex>
> = new LazyImport(lazyModule, m => m.getAlignSections);
export const lazyGetChangeCaseSections: LazyImport<
    typeof lazyIndex.getChangeCaseSections,
    LazyModule<typeof lazyIndex>
> = new LazyImport(lazyModule, m => m.getChangeCaseSections);
export const lazyGetFontColorSections: LazyImport<
    typeof lazyIndex.getFontColorSections,
    LazyModule<typeof lazyIndex>
> = new LazyImport(lazyModule, m => m.getFontColorSections);
export const lazyGetFontBackColorSections: LazyImport<
    typeof lazyIndex.getFontBackColorSections,
    LazyModule<typeof lazyIndex>
> = new LazyImport(lazyModule, m => m.getFontBackColorSections);
export const lazyGetStyleSections: LazyImport<
    typeof lazyIndex.getStyleSections,
    LazyModule<typeof lazyIndex>
> = new LazyImport(lazyModule, m => m.getStyleSections);
export const lazyGetSpacingSections: LazyImport<
    typeof lazyIndex.getSpacingSections,
    LazyModule<typeof lazyIndex>
> = new LazyImport(lazyModule, m => m.getSpacingSections);
export const lazyGetBorderSections: LazyImport<
    (
        editorId: string,
        composeId: string,
        retriever: (composeId: string) => RibbonViewStateInfo | null,
        formatState: PictureFormatState
    ) => MenuSection[],
    LazyModule<typeof lazyIndex>
> = new LazyImport(lazyModule, m => m.getBorderSections);
export const lazyGetShadowSections: LazyImport<
    (editorId: string, pictureFormatState: PictureFormatState) => MenuSection[],
    LazyModule<typeof lazyIndex>
> = new LazyImport(lazyModule, m => m.getShadowSections);
export const lazyGetPictureSizeSections: LazyImport<
    (editorId: string, formatState: PictureFormatState, maxWidth?: number) => MenuSection[],
    LazyModule<typeof lazyIndex>
> = new LazyImport(lazyModule, m => m.getPictureSizeSections);
export const lazyGetTableAlignSections: LazyImport<
    (editorId: string, tabId: number | undefined) => MenuSection[],
    LazyModule<typeof lazyIndex>
> = new LazyImport(lazyModule, m => m.getTableAlignSections);
export const lazyGetTableBorderWeightSections: LazyImport<
    (borderState: TableBorderFormatState) => MenuSection[],
    LazyModule<typeof lazyIndex>
> = new LazyImport(lazyModule, m => m.getTableBorderWeightSections);
export const lazyGetTableBorderColorSections: LazyImport<
    (editorId: string, borderState: TableBorderFormatState) => MenuSection[],
    LazyModule<typeof lazyIndex>
> = new LazyImport(lazyModule, m => m.getTableBorderColorSections);
export const lazyGetApplyTableBorderSections: LazyImport<
    (
        editorId: string,
        tabId: number,
        retriever: (composeId: string) => RibbonViewStateInfo | null,
        composeId: string
    ) => MenuSection[],
    LazyModule<typeof lazyIndex>
> = new LazyImport(lazyModule, m => m.getApplyTableBorderSections);
